module.exports = __webpack_public_path__ + "img/pielegnacja_podlogi.1ebd0ac6.jpg";